var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pieChart"},[(_vm.$route.path.includes('/analytics'))?_c('div',[_c('Pie',{staticStyle:{"height":"250px","width":"430px"},attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1):_c('div',[_c('Pie',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }